import { createLogger } from "@/logger";

const log = createLogger("telemetry");

export type IdleTransition = "idle-enter" | "idle-exit" | null;

export class InactivityMonitorService {
  private lastActivityAt = Date.now();
  private isListening = false;
  private wasIdle = false;
  private idleThresholdMs = 30_000;

  public start(): void {
    if (this.isListening) return;
    this.isListening = true;
    log.info(`[${this.constructor.name}] Listening for activity events`);

    const onActivity = () => {
      this.lastActivityAt = Date.now();
    };

    window.addEventListener("mousemove", onActivity, { passive: true });
    window.addEventListener("keydown", onActivity, { passive: true });
    window.addEventListener("touchstart", onActivity, { passive: true });
    window.addEventListener("scroll", onActivity, { passive: true });
  }

  public get inactivityDurationMs(): number {
    return Date.now() - this.lastActivityAt;
  }

  public get isIdle(): boolean {
    return this.inactivityDurationMs >= this.idleThresholdMs;
  }

  public consumeIdleTransition(): IdleTransition {
    const currentlyIdle = this.isIdle;
    const transition: IdleTransition =
      currentlyIdle && !this.wasIdle ? "idle-enter" : !currentlyIdle && this.wasIdle ? "idle-exit" : null;
    this.wasIdle = currentlyIdle;
    return transition;
  }
}
